'use client';

import type { ReactEventHandler, ReactNode } from 'react';
import Button, { ButtonVariants } from '@pixum/button';

interface ProceedButtonProps {
  children: ReactNode;
  href?: string;
  type?: 'button' | 'submit' | 'reset';
  variant?: ButtonVariants;
  isBusy?: boolean;
  isClickable?: boolean;
  disabled?: boolean;
  /** Accessible name (Button sets aria-label and title); should start with the visible text. */
  ariaLabel?: string;
  onClick?: ReactEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export function ProceedButton({
  children,
  href,
  type = 'button',
  variant = ButtonVariants.PRIMARY,
  isBusy,
  isClickable,
  disabled,
  ariaLabel,
  onClick
}: ProceedButtonProps) {
  return (
    <Button
      href={href}
      type={type}
      variant={variant}
      isBusy={isBusy}
      isClickable={isClickable}
      disabled={disabled}
      label={ariaLabel}
      onClick={onClick}
    >
      {children}
    </Button>
  );
}
